import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import useModalAgendamento, { LOAD_MESSAGE } from './ModalAgendamentoHook'
import { Btn, CustomCalendar, CustomModal } from '../../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../../store/actions/system.actions'

function ModalAgendamento({ show, onModalClose, onModalSave, dispatch, data }) {
  const { state, localDispatch } = useModalAgendamento()

  useEffect(() => {
    if (show) {
      localDispatch.onInit(data)
    }
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE_UPDATE:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveUpdateAgendamento(state.data)
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        dispatch(hideLoadingBox())
        onModalSave(state.data)
        localDispatch.resetState()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetError()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Agendamentos Cargas Paradas"
      isVisible={show}
      width={850}
      onClose={() => {
        localDispatch.resetState()
        onModalClose()
      }}
    >
      <form className="p-grid">
        <div className="p-col-6">
          <CustomCalendar
            marginTop={9}
            label="Data de Agendamento:"
            value={state.data.date}
            onChange={value => localDispatch.onInputChange('date', value)}
            showTime
            hourFormat="24"
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.data)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalAgendamento)
